import React from 'react';

const Tab = ({ children }: any) => <>{children}</>;

export default Tab;
